@if (guides.length) { @if (title) {
<div class="page-sub-description ion-text-left">{{ title }}</div>
}
<!-- Swiper: mobile always; on desktop too for the "resume" (Continue) sections. -->
<div
    class="gs__mobile"
    [class.hide-desktop]="variant !== 'resume'"
    [class.gs__mobile--resume]="variant === 'resume'"
>
    <swiper-container
        class="gs__swiper"
        slides-per-view="auto"
        space-between="5"
    >
        @for (guide of mobileGuides; track trackByGuideId($index, guide)) {
        <swiper-slide class="gs__swiper-slide">
            <app-guide-card
                [guide]="guide"
                [variant]="variant"
                (guideClick)="guideClick.emit($event)"
            >
            </app-guide-card>
        </swiper-slide>
        } @if (showMobileSeeMore) {
        <swiper-slide class="gs__swiper-slide">
            <app-see-more-card [route]="seeMoreRoute"></app-see-more-card>
        </swiper-slide>
        }
    </swiper-container>
</div>
<!-- Desktop: grid (not for the resume slider). -->
@if (variant !== 'resume') {
<div class="gs__desktop hide-mobile">
    <div class="gs__grid">
        @for (guide of desktopGuides; track trackByGuideId($index, guide)) {
        <app-guide-card
            [guide]="guide"
            [variant]="variant"
            (guideClick)="guideClick.emit($event)"
        >
        </app-guide-card>
        }
    </div>
    @if (showDesktopSeeMore) {
    <div class="gs__divider"></div>
    <a class="gs__more" [routerLink]="seeMoreRoute">
        <img src="/assets/icons/see_more_icon.png" alt="" />
        {{ lang.data["general.see_more"] || "See more" }}
    </a>
    }
</div>
} }
